import "./App.css";
import { Routes, Route, useNavigate, Navigate } from "react-router-dom";
import Login from "./pages/login";
import Home from "./pages/home";
import Manager from "./pages/manager";
import { Toaster } from "react-hot-toast";
import { getUserData } from "./redux/Auth/actions";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Protected from "./component/ProtectedRoute";
import Loader from "./component/loader";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const token = localStorage.getItem("token");
  const userData = useSelector((state) => state?.Auth?.userData?.data);
  const [initialLoading, setInitialLoading] = useState(true);

  useEffect(() => {
    if (token) {
      getUserData(dispatch).then(() => {
        setInitialLoading(false);
      }).catch(() => {
        setInitialLoading(false);
      });
    } else {
      setInitialLoading(false);
    }
  }, [token, dispatch]);

  useEffect(() => {
    if (!initialLoading) {
      if (token) {
        if (userData?.role === "Manager" || userData?.role === "Admin") {
          if (window.location.pathname === "/") {
            navigate("/manager/transactions");
          }
        } else if (userData?.role === "Store") {
          if (window.location.pathname === "/") {
            navigate("/home/dashboard/sale");
          }
        }
      } else {
        if (window.location.pathname !== "/") {
          navigate("/");
        }
      }
    }
  }, [token, userData, navigate, initialLoading]);

  if (initialLoading) {
    return (
      <div className="h-screen w-full flex items-center justify-center bg-white">
        <div className="flex flex-col items-center gap-4">
          <Loader />
          <p className="text-gray-500 font-medium">Loading your profile...</p>
        </div>
      </div>
    );
  }

  return (
    <>
      <Toaster position="top-right" reverseOrder={false} />
      <Routes>
        <Route
          path="/"
          element={
            token ? (
              userData?.role === "Store" ? (
                <Navigate to="/home/dashboard/sale" replace />
              ) : (
                <Navigate to="/manager/transactions" replace />
              )
            ) : (
              <Login />
            )
          }
        />
        {token && (
          <>
            {userData?.role === "Store" && (
              <Route path="/home/*" element={<Protected Cmd={Home} />} />
            )}
            {(userData?.role === "Manager" || userData?.role === "Admin") && (
              <Route path="/manager/*" element={<Protected Cmd={Manager} />} />
            )}
          </>
        )}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </>
  );
}

export default App;
